module.exports = "<div [@dialog] *ngIf=\"visible\" class=\"dialog\">\n    <ng-content></ng-content>\n    <button *ngIf=\"closable\" (click)=\"close($event)\" aria-label=\"Close\" class=\"dialog__close-btn\">{{closed}}</button>\n  </div>\n  <div *ngIf=\"visible\" class=\"overlay\"></div>\n  <!-- <div *ngIf=\"visible\" class=\"overlay\" (click)=\"close()\"></div> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/dialog.component.html
// module id = ./src/app/dialog/dialog.component.html
// module chunks = main